export enum UserType {
    INDIVIDUAL = 'PAR',
    ENTERPRISE = 'SIN'

}